const to_currency = (amount_in_cents: number, currency: string) => {
  return (amount_in_cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  })
}

export { to_currency }
